document.addEventListener('DOMContentLoaded', function() {
    function initCartAddonSwiper(selector, config = {}) {
        const slider = document.querySelector(selector);
       
        if (!slider || slider.classList.contains('swiper-initialized')) return;

        new Swiper(slider, {
            spaceBetween: 12,
            ...config
        });
    }

    initCartAddonSwiper('.cart-addon-swiper-page', {
        slidesPerView: 1.15,
            breakpoints: {
            768: {
                slidesPerView: 1.5
            },
            1024: {
                slidesPerView: 1.75
            },
            1200: {
                slidesPerView: 2
            },
            1400: {
                slidesPerView: 2.5
            },
        }
    });

    document.addEventListener('drawerOpen', function() {
        initCartAddonSwiper('.cart-addon-swiper', {
            slidesPerView: 1.15
        });
    });

    document.addEventListener('click', async function(evt) {
        const button = evt.target.closest('[data-addon-atc]');

        if (!button) return;

        evt.preventDefault();

        const variantId = button.dataset.variantId;

        button.disabled = true;
        button.textContent = 'Adding...';

        try {
            await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
            });

            document.dispatchEvent(
            new CustomEvent('cart:build')
            );

            button.textContent = 'Added';
        } catch(error) {
            console.error(error);
            button.textContent = 'Error';
        }

        setTimeout(() => {
            button.disabled = false;
            button.textContent = 'Add';
        }, 1500);
    });


    function moveGovxWidget() {
        const widget = document.querySelector('.govx-id-full-wrapper');

        const target = document.querySelector('.cart-addon-wrapper');

        if (!widget || !target) return;

        if (target.contains(widget)) return;

        target.appendChild(widget);
    }

    const govxObserver = new MutationObserver(() => {
        moveGovxWidget();
        });

    govxObserver.observe(document.body, {
        childList: true,
        subtree: true
    });

    moveGovxWidget();
})